import {
  testTypes as testTypesConstants,
  userPermissions as userPermissionTypes,
  roleuser,
} from '@edulastic/constants'

const SCHOOL_COMMON_BASE = 'school common assessment'
const DISTRICT_COMMON_BASE = 'common assessment'

export const testTypeGroups = {
  INDIVIDUAL: 'individual',
  COMMON: 'common',
}

export const resolveBaseType = (key, userTestTypesInternal) =>
  userTestTypesInternal?.[key]?.baseType || key

const getCommonTypeSortRank = (key, userTestTypesInternal) => {
  const baseType = resolveBaseType(key, userTestTypesInternal)
  if (baseType === SCHOOL_COMMON_BASE) {
    return 0
  }
  if (baseType === DISTRICT_COMMON_BASE) {
    return 1
  }
  return 2
}

export const sortCommonTestTypeKeys = (keys, userTestTypesInternal) =>
  [...keys].sort((a, b) => {
    const rankDiff =
      getCommonTypeSortRank(a, userTestTypesInternal) -
      getCommonTypeSortRank(b, userTestTypesInternal)
    if (rankDiff !== 0) {
      return rankDiff
    }
    return a.localeCompare(b)
  })

const pickByBase = (keys, base, userTestTypesInternal) =>
  // Prefer the standard base type itself over any custom type that merely
  // shares the base, so ordering of `keys` can't make us default to a custom
  // (e.g. PLC) school-common type instead of School Common.
  keys.find((key) => key === base) ||
  keys.find((key) => resolveBaseType(key, userTestTypesInternal) === base)

/**
 * Default subtype when switching Individual ↔ Common in Advanced Test Type UI.
 * @param {string} testTypeGroup
 * @param {Object.<string, string>} testTypes label map
 * @param {{ userRole?: string, allTestTypesInternal?: Object, userTestTypesInternal?: Object }} [options]
 */
export const getDefaultTestTypeForGroup = (
  testTypeGroup,
  testTypes,
  { userRole, allTestTypesInternal = {}, userTestTypesInternal } = {}
) => {
  if (testTypeGroup === testTypeGroups.INDIVIDUAL) {
    return 'assessment'
  }

  const commonGroup = allTestTypesInternal.COMMON || []
  const commonKeys = Object.keys(testTypes || {}).filter((key) =>
    commonGroup.includes(key)
  )

  if (!commonKeys.length) {
    return 'assessment'
  }

  const preferredBase =
    userRole === roleuser.DISTRICT_ADMIN
      ? DISTRICT_COMMON_BASE
      : SCHOOL_COMMON_BASE

  const preferredKey = pickByBase(
    commonKeys,
    preferredBase,
    userTestTypesInternal
  )
  if (preferredKey) {
    return preferredKey
  }

  return sortCommonTestTypeKeys(commonKeys, userTestTypesInternal)[0]
}

export const getPermissionWarningType = (
  userPermissions,
  testType,
  userTestTypesInternal
) => {
  if (
    userPermissions.includes(
      testTypesConstants.TEST_TYPE_PERMISSIONS_MAP[testType]
    ) ||
    userPermissions.includes(
      testTypesConstants.TEST_TYPE_PERMISSIONS_MAP[
        userTestTypesInternal[testType]?.baseType
      ]
    ) ||
    userPermissions.includes(userPermissionTypes.AUTHOR) ||
    userPermissions.includes(userPermissionTypes.CURATOR)
  ) {
    return false
  }
  return testType
}
